export default {
  crop: {
    header: 'Crop Insurance',
    body: `<div class="title-sm">Keep Your Farm Afloat in Times of Trouble</div>
<p>The farming and agricultural industry often involves risk and uncertainty.
From unexpected natural disasters to major economic changes in the marketplace,
many situations can affect the productivity of your agribusiness.</p>

<p>At SIG & Associates, we know that the success of your farm directly impacts the
livelihood of you and your family. With the right Crop Insurance coverage,
you can protect your business and keep your farm afloat through all of the difficult times.</p>

<p>SIG & Associates offers two basic types of Crop Insurance for your farm or ranch:</p>

<ul>
<li><b>Crop-yield insurance</b> covers excess losses to your crops due to natural
disasters such as drought or flood as well as other perils like insects or disease.</li>
<li><b>Crop-revenue insurance</b> covers negative changes in the price of a crop
that occurs during the crop’s growing season.</li>
</ul>

<p>You’ve poured years of hard labor and honest work into your agribusiness, and when times are tough,
you’ll need an agency you can depend on. Talk to a specialist at SIG & Associates to learn more about
how Crop Insurance can help ensure the continued service of your farm for years to come.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  owners: {
    header: 'Farm Owners Insurance',
    body: `<div class="title-sm">You’ve Made It Your Living. Keep It Protected.</div>

<p>There are probably a lot of reasons for why you chose to make your living on the farm –
from the independence and freedom that comes with owning your own business to knowing the
value of a hard day’s work. At SIG & Associates, we’re in the business of seeing yours succeed.
We know that your farm or ranch provides a valuable service to the community, and we’d
like to return the favor by offering you the comprehensive protection you deserve.</p>

<p>A Farm Owners policy from SIG & Associates is an all-inclusive and customizable insurance
solution to secure your land, your property, and your finances against a number of inevitable
situations that can arise on your farm. The basic package includes property coverage for your dwelling,
personal property, and other structures, as well as the added peace of mind that
comes with comprehensive liability coverage.</p>

<div class="title-sm">Dwelling</div>

<p>For most people, a farm is more than a place to work –
it’s also where you lay your head after a long day. Under the dwelling portion of your
Farm Owners policy, SIG & Associates will help pay for damages to your home and any attached
structures for all accidents and perils included in your policy.</p>

<div class="title-sm">Personal Property</div>

<p>Your Farm Owners policy also covers losses that may arise due to the damage or
theft of personal belongings such as clothing, electronics, or home appliances.
Items used in daily farm operations such as machinery, automobiles, and animals are not
eligible for coverage under the personal property section of your policy, as they require additional protection.</p>

<div class="title-sm">Liability</div>

<p>Liability protection from SIG & Associates helps pay for legal fees, medical expenses,
and other losses that you may be held liable for that result from covered injuries or damage
to other people’s property. Further coverage options, including employee injury liability,
are available for an additional premium.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  livestock: {
    header: 'Farm Livestock Insurance',
    body: `<div class="title-sm">Animals Are Assets Too</div>

<p>As the owner and operator of an independent farm or ranch, you’ve made a number of investments into your
agribusiness – equipment, machinery, and crops. Livestock is also a big investment for farmers and ranchers alike,
and like any financial asset, you’ll want to ensure a high-level of security and
protection – so your animals will stay covered.</p>

<p>At SIG & Associates, we know that the health and safety of your animals
directly affects the health and profitability of your farm. Livestock Insurance can
protect you and your farm against the financial losses that could occur if your animals are
harmed or killed as a result of a covered accident such as a fire, blizzard,
or other natural disaster – even when your animals in transit.</p>

<p>Livestock Insurance policies will vary from person to person, farm to farm,
and animal to animal. The insurance value of each animal is usually its purchase price,
but other factors such as performance level or value of your animal’s offspring can increase that value.
A specialist at SIG & Associates can help you determine the right amount of
coverage at a price that meets your needs.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  equine: {
    header: 'Equine Insurance',
    body: `<div class="title-sm">Live to Ride</div>
<p>You’ve spent time training, taking care of, and most likely competing with your horse.
And as a proud owner, it’s up to you to ensure its safety and well being.
Since your horse represents both a financial and emotional investment, medical expenses can be costly.</p>

<p>An Equine Insurance policy from SIG & Associates provides coverage for a
variety of costs and expenses related to the upkeep of your animal.
Our policy options include:</p>

<ul>
<li><b>Full Mortality and Theft</b> – to insure your animals against death as a result of injury, illness, disease, humane destruction, transportation, or theft.</li>
<li><b>Major Medical Coverage*</b> – to provide reimbursement for the cost of medical and surgical bills caused by accident, sickness, or disease.</li>
<li><b>Loss of Use – for compensation</b> in the event your horse becomes totally and permanently unable to perform the duty for which it was insured.</li>
<li><b>Stallion infertility</b> – for coverage in the event your stallion becomes permanently incapable of producing offspring due to an accident, illness, or disease.</li>
</ul>

<p>Finding the right coverage options for your horse doesn’t have to be difficult.
At SIG & Associates, one of our insurance specialists can help educate you on the different
coverage options and rates available for your special animal, and together you can build the
perfect policy that fits the needs of you and your horse.</p>

<p><small><i>*Major Medical Coverage is an addition to the Full Mortality policy and cannot be purchased alone.</i></small></p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  equipment: {
    header: 'Farm Equipment Insurance',
    body: `<div class="title-sm">Keep Your Equipment Running Strong</div>
<p>As a farmer, you rely on your equipment to run like clockwork.
But in the event of equipment breakdown or failure, it can be difficult and expensive to repair.
Damaged or broken equipment can easily cost thousands of dollars to replace,
which is why Farm Equipment Insurance is just as important to your agribusiness as the equipment itself.</p>

<p>At SIG & Associates, we’re dedicated to the success of your farm or ranch, and we understand
that equipment breakdown can mean lost income. That’s why we design comprehensive
insurance policies to keep farms running smoothly in the event of an accident.
Equipment breakdown coverage goes beyond your standard Property Insurance policy to
protect against damage caused by power surges, mechanical breakdown, motor burnout, and even operator error.</p>

<p>Equipment and machinery included under a Farm Equipment Insurance policy includes, but is not limited to:</p>

<ul>
<li>Heating and Cooling Systems</li>
<li>Production Equipment</li>
<li>Boilers, Pressure Vessels, and Water Heaters</li>
<li>Pumps</li>
<li>Electrical Distribution Systems</li>
<li>Refrigeration Equipment</li>
</ul>

<p>Contact SIG & Associates today to find out how a Farm Equipment Insurance policy can keep the productivity of your farm moving.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  dwelling: {
    header: 'Farm Dwelling Insurance',
    body: `<div class="title-sm">It’s More Than A Farm. It’s Your Home</div>
<p>Operating a farm or ranch is a unique business in many ways.
One big difference from most other jobs is that many farmers don’t just work on their property -
they live there too. And having the right protection depends on the situation of each individual family.</p>

<p>While not as comprehensive as a complete Farm Owners policy, some people
may find that Farm Dwelling coverage is enough to meet their needs.</p>

<p>Dwelling Insurance from SIG & Associates protects the building you live in and any attached structures,
including rental properties, by helping to pay for damages that result from a covered incident.
Depending on your specific policy options, it can also include additional coverage for personal property
or provide additional living expenses if your home becomes uninhabitable due to a covered loss.</p>

<p>Other insurance provisions such as Liability or Medical Payments coverage are not included in a Farm Dwelling policy,
so if you’re looking for a more complete solution for all your Farm Insurance needs, a comprehensive
Farm Owners policy may be the right choice for you. Talk to a specialist at SIG & Associates to learn
more about how our insurance solutions can best benefit your agribusiness.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  structures: {
    header: 'Farm Structures Insurance',
    body: `<div class="title-sm">Secure Your Farm From the Ground Up</div>

<p>As the owner of a successful agribusiness, your farm or ranch contains some of your biggest physical assets.
Barns, machine sheds, and granaries are essential elements that keep your farming operations running smoothly,
but in the event of a disaster, the loss of important property can disrupt business and be financially devastating.</p>

<p>Protecting your buildings and your livelihood is easy with a Farm Structures policy from SIG & Associates.
This coverage helps pay for the accidental loss of property used for farming purposes
due to a variety of perils such fires and some natural disasters.</p>

<p>At SIG & Associates, we strive to meet all of your insurance needs around the farm.
In addition to securing your important farm structures, we also offer impressive solutions to protect
the expensive machinery and equipment vital to your day-to-day operations. Talk with one of our professional
insurance specialists to learn more about our farm insurance options and how we can
tailor the perfect package for you and your business.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  auto: {
    header: 'Farm Auto Insurance',
    body: `<div class="title-sm">Stay Safe Both On and Off the Farm</div>

<p>Whether you’re hauling grain or transporting livestock, the vehicles you use around the
farm are a vital part of your day-to-day operations, and you can’t afford for them not to be working properly.
With a Farm Auto Insurance policy from SIG & Associates, you can protect everything from your personal
truck or car to the trailer you use to deliver and transport your valuable goods.</p>

<p>Even if you take good care of your farm equipment, some situations are simply out of your control
such as road conditions, bad weather, and other drivers. And in the event that something should happen,
that’s where your Farm Auto Insurance comes in. At SIG & Associates, we’ll help you
create a policy to fit your unique insurance needs.</p>

<p>Whether you rent or own your farm vehicles, you can still get
the same great coverage with benefits that can include:</p>

<ul>
<li>Auto Liability</li>
<li>Medical Payments</li>
<li>Collision Coverage</li>
<li>Uninsured & Underinsured Motorist Coverage</li>
<li>Extended Coverage for employees using their vehicles for farm operation</li>
</ul>

<p>At SIG & Associates, we believe that your Farm Auto Insurance policy should work for you.
Contact one our local insurance specialists to learn more about what we can do
for the security of your agribusiness.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  umbrella: {
    header: 'Farm Umbrella Insurance',
    body: `<div class="title-sm">Extra Security to Protect your Hard Work</div>
<p>SIG & Associates knows that your farm is your business. And like any business owner,
you’re faced with a certain amount of risk and uncertainty in your day-to-day operations.
If an accident happens, in most cases, your standard farm owners insurance liability
should take care of you. But when serious situations arise, you’ll want to make sure your business is protected.</p>

<p>Chances are your basic policy liability limits are not enough to cover every potential accident -
including serious accidents that come with serious expenses. A Farm Umbrella policy from
SIG & Associates picks up where your other liability coverage stops. It can be an affordable
way to provide an extra layer of protection against claims of bodily
injury and property damage in scenarios such as:</p>

<ul>
<li>An accident on your farm that leaves multiple workers in need of costly medical attention</li>
<li>If a farm animal escapes and causes an accident or serious damage to another’s property</li>
<li>If someone sues you for damages resulting from an illness from your products</li>
</ul>

<p>At SIG & Associates, our team of farm insurance specialists is dedicated to keeping your
farm up and running, even after an accident. With the right farm umbrella coverage options,
your business won’t have to miss a beat. And, as always, with our 24/7 dedicated
claims service, you can rest assured that our professionals will be there for you when you need it most.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  liability: {
    header: 'Farm Liability Insurance',
    body: `<div class="title-sm">Safety and Reassurance On Your Farm</div>
<p>A great amount of responsibility goes into running a farm or ranch.
From the operation of farm machinery and equipment to the sometimes unpredictable
nature of barnyard animals, farmers are subject to a much higher risk of liability
than other property owners. SIG & Associates understands this risk,
and is proud to offer complete liability protection for you and your agribusiness.</p>

<p>Under a standard Farm Liability Insurance policy, SIG & Associates will help cover
the expenses in which you become legally obligated to pay for bodily injury claims
on your property and damages to another person’s property as a result of a covered accident.</p>

<p>Some common liability expenses covered under your policy include:</p>

<ul>
<li>Attorney fees and court costs</li>
<li>Medical expenses for people injured on your property</li>
<li>Injury or damage to another’s property caused by your animals</li>
<li>Other claims for injury resulting from specific farm operations</li>
</ul>

<p>SIG & Associates is committed to serving you. That’s why we strive to offer insurance
solutions to meet the individual needs of you and your business. There are a number of factors
that may influence the type of coverage you’ll need, such as the size and type of your farm.
Our farm insurance professionals will help you design the right policy to ensure
that all of your special interests are protected.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/farmHelper.js